export default class {
  async get({ id }) {
    const res = await fetch(`${process.env.API_URL}/matches/${id}/result`, {
      headers: { "x-version": 2 },
    });
    if (res.ok) {
      return res.json();
    }
    throw new Error(res.statusText);
  }
}
